import axios from 'axios';
import { EventBus } from './Eventbus';
import configRepository from './ConfigRepository';

var WarmingTrayRepository = function () {
  
    var _config = configRepository.getConfig();
           
    function _callApi(action, data) {

        var url = _config.endPointUrl + 'api/WarmingTray/' + action;

        // Creating a promise
        var promise = new Promise(function (resolve, reject) {
            
            axios({
                method: (data ? 'POST' : 'GET'),
                url: url,
                data : data,
                withCredentials: true
            }).then(function (response) {
                if (response.data.success) {

                    if (action == 'getWarmingTrays' || action == 'getWarmingTraysForOverlay') {
                        response.data.data.forEach(b => {
                            try {
                                b.activateAt = new Date(b.activateAt);
                                b.deactivateAt = new Date(b.deactivateAt);
                            } catch (e) {
                                //ignore
                            }
                        });
                    }
                    
                    resolve(response.data.data);
                }
                else
                    reject(response.data.messages);
            }).catch(function (err) {
                window.console.log('#RescheduleRepository: Error calling ' + action + ' :' + err);
                reject(err);
            });

        });

        return promise;
    }

    var _data = {

        warmingTrays: [],

        applyWarmingTrays: function (warmingTrays) {
            return _callApi('PostWarmingTrays', warmingTrays);
        },

        getWarmingTrays: function () {
            return _callApi('getWarmingTrays');
        },
        getWarmingTraysForOverlay: function () {
            return _callApi('getWarmingTraysForOverlay');
        },
        init: function () {
            _callApi('getWarmingTrays').then(a => {
                // reactivenis of vue requires the array to pop and push
                while (_data.warmingTrays.length)
                    _data.warmingTrays.pop();
                    
                _data.warmingTrays.push(...a);
            });
        }
    };

    _data.init();

    // event handler, when warming trays are changed on the server, reinit the warming trays
    EventBus.$on('warmingtrays-changed', () => {
        _data.init();
    });

    return _data;
}()

export { WarmingTrayRepository as default };